import React from 'react';
import { formatSizeSpaced } from '../utils/formatSize';

function VariationPopup({ variations, onSelect, onClose }) {
  return (
    <div className="auth-popup-overlay" onClick={onClose}>
      <div className="auth-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="auth-popup-close" onClick={onClose}>×</button>
        <h2>Оберіть розмір</h2>
        <p style={{ color: '#1a1a1a', fontSize: '0.95rem', marginBottom: '1.5rem' }}>
          Виберіть потрібний розмір для додавання в кошик
        </p>
        <div style={{ marginBottom: '2rem' }}>
          {variations.map((variation) => (
            <button
              key={variation.id}
              className="variation-btn"
              onClick={() => onSelect(variation)}
            >
              <span className="variation-size">{formatSizeSpaced(variation.size)}</span>
              <span className="variation-price">{variation.price} ₴</span>
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <button className="auth-btn cancel-btn" onClick={onClose}>
            Скасувати
          </button>
        </div>
      </div>
    </div>
  );
}

export default VariationPopup;
